module.exports = __webpack_public_path__ + "media/kick.625b3ab0.mp3";